import React, {useEffect, useState} from "react";
import styles from './Input.module.scss';

import Tooltip from "../Tooltip/Tooltip";
import {FiInfo} from "react-icons/fi";
import _ from "lodash";
import {$validate} from "../../../helpers/formValidator";

const Input = (props) => {
    const [value, setValue] = useState('');
    const [errors, setErrors] = useState([]);
    const [typingTimeout, setTypingTimeout] = useState(0)

    useEffect(() => {
        // console.log('valchange:', props.value)
        setValue(props.value)
    }, [props.value]);

    function changeHandler(e) {
        if (typingTimeout) {
            clearTimeout(typingTimeout);
        }

        setValue(e.target.value);

        if (props.validations) {
            validate(e.target.value);
        }

        setTypingTimeout(setTimeout(function () {
            // console.log('to parent:', value)
            props.onChange({
                target: {
                    value: e.target.value
                }
            })
        }, props.delay ? props.delay : 0))
    }

    function validate(value) {
        let errorsArr = $validate(value, props.validations);
        // _.forEach(props.validations, (ru, k) => {
        //     errors += $validate(value, rules)
        // })
        setErrors(errorsArr);
        // console.log(errorsArr);
    }


    return (
        <div>
            <div className={styles.container}>
                <input
                    name={props.autoComplete ? props.name : null} //turning off autocomplete by removing name
                    disabled={props.disabled}
                    className={`${'alma-input'} ${styles.select}`}
                    type={props.type}
                    value={value}
                    placeholder={props.placeholder}
                    onChange={(e) => changeHandler(e)}
                />

                {props.tooltip ?
                    <span className={styles.tooltip}>
                        <Tooltip content={props.tooltip}>
                            <FiInfo className={styles.infoIcon}/>
                        </Tooltip>
                    </span>
                    :
                    null
                }

            </div>
            {props.validations && props.validations.length ?
                <div className={styles.errorsContainer}>
                    {
                        errors.map(function (v, k) {
                            return (
                                <div className={styles.error}>{v}</div>
                            )
                        })
                    }
                </div>
                :
                null
            }
        </div>
    )
}

Input.defaultProps = {
    delay: 0,   //ms
    validations: null,
    name: false,
    disabled: false,
    className: 'alma-input',
    type: 'text',
    value: '',
    placeholder: '',
    tooltip: '',
    onChange: () => console.log('Please provide an "onChange={() => functionToTrigger()" prop to Input component'),
    autoComplete: true,
}

export default Input;
